<button mat-flat-button class="ci-btn-filter" color="primary" (click)="submit()" matTooltip="Filtrar">
    <mat-icon>search</mat-icon>
</button>
<button mat-stroked-button class="ci-btn-filter" (click)="toggleFiltro()" matTooltip="Abrir Filtros">
    <mat-icon>filter_list</mat-icon>
    Filtros
</button>
<button mat-flat-button class="ci-btn-filter" color="warn" (click)="limpaForm()" matTooltip="Limpar Filtros">
    <mat-icon>delete</mat-icon>
</button>

<div class="filter-backdrop" *ngIf="aberto" (click)="fecharFiltro()"></div>

<div class="filter-sidebar mat-elevation-z8" [class.open]="aberto">

    <div class="filter-header d-flex align-items-center justify-content-between px-3 py-3">
        <h3 class="m-0 font-weight-bold">Filtros</h3>
        <button mat-icon-button (click)="fecharFiltro()">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <div class="filter-content px-3 py-3">
        <div *ngFor="let filtroSelecionado of filtrosForm.controls; let i = index;" class="filter-row mb-3">

            <div class="row" *ngIf="exibirComposicao(i)">
                <div class="col-12">
                    <mat-form-field appearance="outline" class="w-100 dense-field">
                        <mat-label>Composição</mat-label>
                        <mat-select [formControl]="filtroSelecionado.get('composicao')">
                            <mat-option [value]="'AND'">E</mat-option>
                            <mat-option [value]="'OR'">Ou</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>

            <div class="filter-group-box p-2 border rounded">
                <mat-form-field appearance="outline" class="w-100 dense-field">
                    <mat-label>Campo</mat-label>
                    <mat-select [formControl]="filtroSelecionado.get('propriedade')">
                        <mat-option *ngFor="let filtro of filtrosExibidos()" [value]="filtro.propriedade">
                            {{filtro.descricao}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>

                <mat-form-field appearance="outline" class="w-100 dense-field">
                    <mat-label>Condição</mat-label>
                    <mat-select [formControl]="filtroSelecionado.get('condicao')">
                        <mat-option *ngFor="let condicao of condicoesFiltradas(filtroSelecionado.get('propriedade').value)"
                            [value]="condicao.valor">
                            {{condicao.descricao}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>

                <mat-form-field appearance="outline" class="w-100 dense-field" *ngIf="exibirCampoPadrao(filtroSelecionado)">
                    <mat-label>Valor</mat-label>
                    <input matInput placeholder="Digite para pesquisar..." [formControl]="filtroSelecionado.get('termo')" />
                </mat-form-field>

                <mat-form-field appearance="outline" class="w-100 dense-field" *ngIf="exibirCampoBooleano(filtroSelecionado)">
                    <mat-label>Valor</mat-label>
                    <mat-select [formControl]="filtroSelecionado.get('termo')">
                        <mat-option [value]="'True'">Sim</mat-option>
                        <mat-option [value]="'False'">Não</mat-option>
                    </mat-select>
                </mat-form-field>

                <mat-form-field appearance="outline" class="w-100 dense-field" *ngIf="exibirCampoData(filtroSelecionado)">
                    <mat-label>Data</mat-label>
                    <input matInput [matDatepicker]="picker" [formControl]="filtroSelecionado.get('termo')" placeholder="dd/mm/aaaa">
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                </mat-form-field>

                <mat-form-field appearance="outline" class="w-100 dense-field" *ngIf="exibirOptions(filtroSelecionado)">
                    <mat-label>Selecione</mat-label>
                    <mat-select [formControl]="filtroSelecionado.get('termo')">
                        <mat-option *ngFor="let opcao of options(filtroSelecionado.get('propriedade').value)" [value]="opcao.valor">
                            {{opcao.texto}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>

                <div class="text-right mt-2">
                    <button mat-flat-button color="warn" class="mr-2" (click)="removerFiltro(i)" matTooltip="Remover regra">
                        <mat-icon>delete</mat-icon>
                    </button>
                    <button mat-flat-button color="accent" (click)="adicionarFiltro()" *ngIf="exibirAdicionar(i)">
                        <mat-icon>add</mat-icon> Adicionar Condição
                    </button>
                </div>
            </div>
        </div>
    </div>

    <div class="filter-footer p-3 border-top d-flex justify-content-end">
        <button mat-flat-button color="warn" class="mr-2" (click)="limpaForm()">
            <mat-icon>delete</mat-icon>
            Limpar
        </button>
         <button mat-flat-button color="primary" (click)="submit()">
            <mat-icon>search</mat-icon>
            Pesquisar
        </button>
    </div>
</div>
